class FixedHeader {
  constructor(options) {
    this.scroller = document.querySelector(options.scroller)
    this.wrapper = typeof options.wrapper !== 'undefined' ? document.querySelector(options.wrapper) : null
    this.targetClass = options.target
    this.target = document.querySelector(this.targetClass)
    this.type = options.type || 'fixed'
    this.offset = options.offset || 0
    this.targetPosition = this.target.getBoundingClientRect()

    const ua = window.navigator.userAgent.toLowerCase()
    this.isIE = (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0)

    this.init()
  }

  init() {
    const id = Math.floor(Math.random() * 10000)

    if (this.type === 'fixed' && this.wrapper !== null) {
      this.wrapper.style.height = `${this.target.clientHeight}px`
      this.wrapper.style.width = '100%'
      this.wrapper.style.position = 'relative'
    }

    this.scroller.addEventListener('scroll', this.scroll.bind(this))
    window.addEventListener('resize', this.resize.bind(this))
  }

  scroll() {
    const wy = this.scroller.scrollTop
    const ey = window.pageYOffset + (window.innerHeight * 0.1)

    if (wy >= ey) {
      if (this.type === 'fixed') {
        this.target.style.width = '100%'
      }

      if (!this.isIE) {
        this.target.style.position = 'fixed'
      } else {
        this.target.style.position = 'absolute'
      }
      
      this.target.style.top = `${wy - ey + this.offset}px`
    } else {
      if (this.type === 'fixed') {
        this.target.style.position = 'static'
      } else {
        this.target.style.position = this.type
        this.target.style.top = ''
      }
    }
  }

  resize() {
    this.targetPosition = this.target.getBoundingClientRect()
  }

  destroy() {
    this.scroller.removeEventListener('scroll', this.scroll.bind(this))
    
    if (this.type === 'fixed') {
      this.target.style.position = 'static'
    } else {
      this.target.style.position = this.type
      this.target.style.top = ''
    }
  }
}

export { FixedHeader }
